import { Map } from 'immutable';
import 'prop-types';
import { getGaSearchTermValueFromSearchContext } from '@dbh/get-ga-search-term-value-from-search-context';
import '@dbh/search-context-types';
import withConformsTo from '@dbh/with-conforms-to-for-production-www';

/**
 * Creates and returns the `GA4` native `Search` event.
 * @param {Immutable.Map} searchContext .
 * @return {Immutable.Map} .
 * @see {@link https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=16020532435091790835-EU&client_type=gtag#search}
 */const createAnalyticsEventSearch=withConformsTo("createAnalyticsEventSearch",[],(a,b)=>{const c=getGaSearchTermValueFromSearchContext(a);return Map({eventPastTense:"Search",search_term:c,lat:null==b?void 0:b.lat,lng:null==b?void 0:b.lng})});var createAnalyticsEventSearch$1 = createAnalyticsEventSearch;

/**
 * Creates and returns the `GA4` native `Search` event, with the custom
 * dimension `isNoResults` set.
 * @param {Immutable.Map} searchContext .
 * @return {Immutable.Map} .
 * @see {@link https://analytics.google.com/analytics/web/?authuser=1#/a39589072p344388821/admin/customdefinitions/hub}
 * @see {@link https://analytics.google.com/analytics/web/?authuser=1#/a39589072p326658850/admin/customdefinitions/hub}
 */const createAnalyticsEventSearchWithNoResults=withConformsTo("createAnalyticsEventSearchWithNoResults",[],(a,b)=>createAnalyticsEventSearch$1(a,b).set("isNoResults","true"));var createAnalyticsEventSearchWithNoResults$1 = createAnalyticsEventSearchWithNoResults;

export { createAnalyticsEventSearch$1 as createAnalyticsEventSearch, createAnalyticsEventSearchWithNoResults$1 as createAnalyticsEventSearchWithNoResults };
